export default __webpack_public_path__ + "static/proper-details-top-video-m-aa0aeb3d3a6a37cad15daa78d0fc6ba5.jpg";